<template>
  <div id="grupoProdutosId">
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-else
    >
      <div
        id="idTable"
        style="overflow-x: auto;"
      >
        <table
          style="width: 100%; color: black; border-collapse: collapse;"
          class="elevation-1"
        >
          <thead>
            <tr>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              />
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('classificacao')"
              >
                Classificação Produto
                <v-icon small>
                  {{ ordenarDados === 'classificacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('quantidadeOrdenacao')"
              >
                Quantidade
                <v-icon small>
                  {{ ordenarDados === 'quantidadeOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('faturamentoOrdenacao')"
              >
                Faturamento
                <v-icon small>
                  {{ ordenarDados === 'faturamentoOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('volumeOrdenacao')"
              >
                Volume (L)
                <v-icon small>
                  {{ ordenarDados === 'volumeOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('precoMedioOrdenacao')"
              >
                PM
                <v-icon small>
                  {{ ordenarDados === 'precoMedioOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('cmvOrdenacao')"
              >
                CMV
                <v-icon small>
                  {{ ordenarDados === 'cmvOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('valorUnitarioOrdenacao')"
              >
                Vr. Unt. Cardex
                <v-icon small>
                  {{ ordenarDados === 'valorUnitarioOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('margemBrutaOrdenacao')"
              >
                Margem Bruta R$
                <v-icon small>
                  {{ ordenarDados === 'margemBrutaOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('margemPorcentagemBrutaOrdenacao')"
              >
                Margem Bruta %
                <v-icon small>
                  {{ ordenarDados === 'margemPorcentagemBrutaOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('margemContribuicaoOrdenacao')"
              >
                Margem Contribuição %
                <v-icon small>
                  {{ ordenarDados === 'margemContribuicaoOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(item, index) in faturamentoGrupoProdutos"
            :key="item.id"
          >
            <!-- Linha principal -->
            <tr>
              <td style="text-align: center;">
                <button @click="toggleExpand(index)">
                  {{ expanded.includes(index) ? '▲' : '▼' }}
                </button>
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: left;"
              >
                {{ item.classificacao }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.quantidade }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.faturamento }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.volume }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.precoMedio }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.cmv }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.valorUnitario }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.margemBruta }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.margemPorcentatemBruta }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.margemContribuicao }}
              </td>
            </tr>
            <!-- Linha expandida -->
            <tr
              v-if="expanded.includes(index)"
              :key="'expanded-' + item.id"
            >
              <td colspan="11">
                <table
                  id="tableExpandida"
                  style="width: 100%; border-collapse: collapse; margin-top: 10px;"
                >
                  <thead>
                    <tr>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center; width: 20.3%"
                        @click="mudarOrdenacaoProduto('produto', index)"
                      >
                        Produto
                        <v-icon small>
                          {{ ordenarDadosProdutos === 'produto' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoProduto('unidade', index)"
                      >
                        Unidade
                        <v-icon small>
                          {{ ordenarDadosProdutos === 'unidade' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoProduto('quantidadeOrdenacao', index)"
                      >
                        Quantidade
                        <v-icon small>
                          {{ ordenarDadosProdutos === 'quantidadeOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoProduto('faturamentoOrdenacao', index)"
                      >
                        Faturamento
                        <v-icon small>
                          {{ ordenarDadosProdutos === 'faturamentoOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoProduto('volumeOrdenacao', index)"
                      >
                        Volume (L)
                        <v-icon small>
                          {{ ordenarDadosProdutos === 'volumeOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoProduto('precoMedioOrdenacao', index)"
                      >
                        PM
                        <v-icon small>
                          {{ ordenarDadosProdutos === 'precoMedioOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoProduto('cmvOrdenacao', index)"
                      >
                        CMV
                        <v-icon small>
                          {{ ordenarDadosProdutos === 'cmvOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoProduto('valorUnitarioOrdenacao', index)"
                      >
                        Vr. Unt. Cardex
                        <v-icon small>
                          {{ ordenarDadosProdutos === 'valorUnitarioOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoProduto('margemBrutaOrdenacao', index)"
                      >
                        Margem Bruta R$
                        <v-icon small>
                          {{ ordenarDadosProdutos === 'margemBrutaOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoProduto('margemPorcentagemBrutaOrdenacao', index)"
                      >
                        Margem Bruta %
                        <v-icon small>
                          {{ ordenarDadosProdutos === 'margemPorcentagemBrutaOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoProduto('margemContribuicaoOrdenacao', index)"
                      >
                        Margem Contribuição %
                        <v-icon small>
                          {{ ordenarDadosProdutos === 'margemContribuicaoOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(sub, idx) in item.dadosProduto"
                      :key="idx"
                    >
                      <td
                        id="dadoMovimentacao"
                        style="text-align: left;"
                      >
                        {{ sub.produto }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: left;"
                      >
                        {{ sub.unidade }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.quantidade }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.faturamento }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.volume }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.precoMedio }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.cmv }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.valorUnitario }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.margemBruta }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.margemPorcentatemBruta }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.margemContribuicao }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import AnaliseMargem from '../../../../../services/analisemargem2'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowFaturamentoVendas',
    emits: ['dadosMargemTotal'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa: [],
      area: [],
      rede: [],
      supervisor: [],
      classificacao: [],
      linhasProducao: [],
      produtos: [],
      cidades: [],
      headersGrupoProdutos: [
        { text: 'Classificação Produto', value: 'classificacao', width: '20%', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Quantidade', value: 'quantidade', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Volume', value: 'volume', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'PM', value: 'precoMedio', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'CMV', value: 'cmv', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Vr. Unt. Cardex', value: 'valorUnitario', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta R$', value: 'margemBruta', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta %', value: 'margemPorcentatemBruta', align: 'right', width: '5%', class: 'black--text title' },
        { text: 'Margem Contribuição %', value: 'margemContribuicao', align: 'right', width: '5%', class: 'black--text title' },
      ],
      headersProdutos: [
        { text: 'Produto', value: 'produto', width: '20%', class: 'black--text title' },
        { text: 'Unidade', value: 'unidade', width: '10%', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Quantidade', value: 'quantidade', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Volume', value: 'volume', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'PM', value: 'precoMedio', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'CMV', value: 'cmv', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Vr. Unt. Cardex', value: 'valorUnitario', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta R$', value: 'margemBruta', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta %', value: 'margemPorcentatemBruta', align: 'right', width: '5%', class: 'black--text title' },
        { text: 'Margem Contribuição %', value: 'margemContribuicao', align: 'right', width: '5%', class: 'black--text title' },
      ],
      faturamentoGrupoProdutos: [],
      expanded: [],
      ordenarDados: '',
      ordenacaoDadosDecrescente: false,
      ordenarDadosProdutos: '',
      ordenacaoDadosProdutosDecrescente: false,
    }),

    created () {
      eventEmit.$on('show-dados-tabela', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('show-dados-tabela', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, area, redes, supervisor, classificacao, linhasProducao, produtos, cidades) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.empresa = select
        this.area = area
        this.rede = redes
        this.supervisor = supervisor
        this.classificacao = classificacao
        this.linhasProducao = linhasProducao
        this.produtos = produtos
        this.cidades = cidades

        this.showMargemGrupoProdutos()
      },

      async showMargemGrupoProdutos () {
        this.loading = true

        this.faturamentoGrupoProdutos = []
        this.expanded = []

        this.ordenarDados = ''
        this.ordenacaoDadosDecrescente = false
        this.ordenarDadosProdutos = ''
        this.ordenacaoDadosProdutosDecrescente = false

        await AnaliseMargem.showAnaliseMargem2GrupoProdutos(this.primeiroDia, this.ultimoDia, this.empresa, this.area, this.rede, this.supervisor, this.classificacao, this.linhasProducao, this.produtos, this.cidades, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.faturamentoGrupoProdutos = resposta.data.dadosGrupoProdutos.map((item) => {
              var listaFaturamento = ({
                classificacao: item.classificacao,
                quantidade: parseFloat(item.quantidade).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                volume: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                precoMedio: 'R$ ' + parseFloat(item.precoMedio).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }),
                cmv: parseFloat(item.cmv).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                valorUnitario: 'R$ ' + parseFloat(item.valorUnitario).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }),
                preco_medio: parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                margemBruta: parseFloat(item.margemBruta).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                margemPorcentatemBruta: parseFloat(item.margemPorcentatemBruta).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                margemContribuicao: parseFloat(item.margemContribuicao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                quantidadeOrdenacao: parseFloat(item.quantidade),
                faturamentoOrdenacao: parseFloat(item.faturamento),
                volumeOrdenacao: parseFloat(item.volume),
                precoMedioOrdenacao: parseFloat(item.precoMedio),
                cmvOrdenacao: parseFloat(item.cmv),
                valorUnitarioOrdenacao: parseFloat(item.valorUnitario),
                preco_medioOrdenacao: parseFloat(item.precoMedio),
                margemBrutaOrdenacao: parseFloat(item.margemBruta),
                margemPorcentagemBrutaOrdenacao: parseFloat(item.margemPorcentatemBruta),
                margemContribuicaoOrdenacao: parseFloat(item.margemContribuicao),
                expandir: item.expandir,
                dadosProduto: this.dadosProdutos(item.dadosProdutos),
              })

              return listaFaturamento
            })

            eventEmit.$emit('dados-margem-total', resposta.data.valorFaturamentoTotal, resposta.data.valorCmvTotal, resposta.data.valorMargemBrutaTotal, resposta.data.porcentagemMargemBrutaTotal, resposta.data.porcentagemMargemContruibuicao)
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado') {
            this.faturamentoGrupoProdutos = []
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      dadosProdutos (value) {
        const dados = value.map((item) => {
          var listaDados = ({
            produto: item.produto,
            unidade: item.unidade,
            quantidade: parseFloat(item.quantidade).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            volume: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            precoMedio: 'R$ ' + parseFloat(item.precoMedio).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }),
            cmv: parseFloat(item.cmv).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            valorUnitario: 'R$ ' + parseFloat(item.valorUnitario).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }),
            preco_medio: parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            margemBruta: parseFloat(item.margemBruta).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            margemPorcentatemBruta: parseFloat(item.margemPorcentatemBruta).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
            margemContribuicao: parseFloat(item.margemContribuicao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
            quantidadeOrdenacao: parseFloat(item.quantidade),
            faturamentoOrdenacao: parseFloat(item.faturamento),
            volumeOrdenacao: parseFloat(item.volume),
            precoMedioOrdenacao: parseFloat(item.precoMedio),
            cmvOrdenacao: parseFloat(item.cmv),
            valorUnitarioOrdenacao: parseFloat(item.valorUnitario),
            preco_medioOrdenacao: parseFloat(item.precoMedio),
            margemBrutaOrdenacao: parseFloat(item.margemBruta),
            margemPorcentagemBrutaOrdenacao: parseFloat(item.margemPorcentatemBruta),
            margemContribuicaoOrdenacao: parseFloat(item.margemContribuicao),
          })

          return listaDados
        })

        return dados
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },

      mudarOrdenacao (campo) {
        if (this.ordenarDados === campo) {
          this.ordenacaoDadosDecrescente = !this.ordenacaoDadosDecrescente
        } else {
          this.ordenarDados = campo
          this.ordenacaoDadosDecrescente = false
        }

        this.buscarDadosOrdenados()
      },

      buscarDadosOrdenados () {
        const novaOrdenacao = [...this.faturamentoGrupoProdutos]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenarDados] < b[this.ordenarDados]) result = -1
          if (a[this.ordenarDados] > b[this.ordenarDados]) result = 1

          if (this.ordenacaoDadosDecrescente) result *= -1

          return result
        })

        this.faturamentoGrupoProdutos = novaOrdenacao
      },

      mudarOrdenacaoProduto (campo, index) {
        if (campo === this.ordenarDadosProdutos) {
          this.ordenacaoDadosProdutosDecrescente = !this.ordenacaoDadosProdutosDecrescente
        } else {
          this.ordenarDadosProdutos = campo
          this.ordenacaoDadosProdutosDecrescente = false
        }

        this.ordenarDadosProduto(index)
      },

      ordenarDadosProduto (index) {
        const novaOrdenacao = [...this.faturamentoGrupoProdutos[index].dadosProduto]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenarDadosProdutos] < b[this.ordenarDadosProdutos]) result = -1
          if (a[this.ordenarDadosProdutos] > b[this.ordenarDadosProdutos]) result = 1

          if (this.ordenacaoDadosProdutosDecrescente) result *= -1

          return result
        })

        this.faturamentoGrupoProdutos[index].dadosProduto = novaOrdenacao
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #grupoProdutos {
      font-size: 10px;
      max-width: 100%
    }

    #idTable {
      max-height: 500px;
      max-width: 370px !important;
      /* margin: 0 0 0 -1rem; */
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }

    #tableExpandida {
      margin: 0 0rem 0 0rem;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #grupoProdutosId {
      width: 100%;
    }

    #grupoProdutos {
      font-size: 10px;
      max-width: 100%;
    }
  }
</style>

<style lang="sass">
  #grupoProdutos
    data-table-scroll-bar-width: 17px

  #tableExpandProdutos
    margin: 0 0 0 3rem

</style>
